import _ from 'lodash';

export default angular
  .module('doxy.common.services.roomHelpersFactory', [])
  .factory(
    'roomHelpersFactory',
    function ($location, baseUrl, VideoProviderFactory, routerHelperFactory) {
      let rooms = [];

      function addSubdomain(url, subdomain) {
        const subdomainDivider = routerHelperFactory.getSubdomainDivider();
        const resolvedSubdomain = Boolean(subdomain)
          ? `${subdomain}${subdomainDivider}`
          : '';
        return [url.replace('//', `//${resolvedSubdomain}`), '/'].join('');
      }

      function setRooms(value) {
        rooms = value;
      }

      function setSharedRooms(newRooms) {
        rooms = rooms.filter((r) => r.isPersonal).concat(newRooms);
      }

      function setRoom(room) {
        rooms = rooms.filter((r) => r.id !== room.id).concat(room);
      }

      function getPersonalRooms() {
        return rooms.filter((room) => room.isPersonal);
      }

      function getRoom() {
        const currentSessionRoomId = _.get(
          VideoProviderFactory,
          'activeProvider.callSession.roomId',
          null
        );
        if (rooms.length > 0) {
          return Boolean(currentSessionRoomId)
            ? rooms.find(({ id }) => id === currentSessionRoomId)
            : rooms[0];
        }
        return null;
      }

      function getRoomSlug(roomId) {
        const room = rooms.find((room) => room.id === roomId);
        return room ? room.slug : undefined;
      }

      function getRoomUrl(room, skipProtocol) {
        const domain = room.institution ? room.institution.domain : '';
        /*
          For development mode in pair with V2 when OG App is proxied:
          replace port that is specified in baseUrl if it is present
          to the actual port where browser is opened
        */
        let url = [
          addSubdomain(baseUrl.replace(/\d{4}$/u, $location.port()), domain),
          room.slug,
        ].join('');

        const query = [];
        if ($location.search().vcp) {
          query.push(`vcp=${$location.search().vcp}`);
        }
        if (query.length > 0) {
          url += `?${query.join('&')}`;
        }

        return skipProtocol ? url.replace(/https*:\/\//, '') : url;
      }

      function getRoomBaseUrl(room, skipProtocol) {
        const domain = room ? room.domain : '';
        const url = addSubdomain(baseUrl, domain);
        return skipProtocol ? url.replace(/https*:\/\//, '') : url;
      }

      function institutionSort(adminRooms, memberRooms, instDomain) {
        const instSorted = [];
        for (const room of adminRooms) {
          if (room.institution && room.institution.domain === instDomain) {
            instSorted.unshift(room);
            continue;
          }

          instSorted.push(room);
          continue;
        }

        return instSorted.concat(memberRooms);
      }

      function sortRooms(rooms, user, instDomain) {
        const adminRooms = [];
        const memberRooms = [];

        rooms.forEach((room) => {
          const isAdminRoom = room.roomMemberships.some(rm => rm.role === 'admin' && rm.userId === user.id);
          if (isAdminRoom) {
            adminRooms.push(room);
          } else {
            memberRooms.push(room);
          }
        });

        const sortedRooms = (
          instDomain
            ? institutionSort(adminRooms, memberRooms, instDomain)
            : adminRooms.concat(memberRooms)
        ).sort((room) => (room.isPersonal ? -1 : 1));

        const userPersonalRoom = _.find(sortedRooms, (sortedRoom) => {
          return _.find(sortedRoom.roomMemberships, {
            role: 'admin',
            userId: user.id,
          });
        });

        // make current user personal room first in array
        _.pull(sortedRooms, userPersonalRoom);
        sortedRooms.unshift(userPersonalRoom);

        return sortedRooms;
      }

      return {
        setRooms,
        setSharedRooms,
        setRoom,
        getRoom,
        getRoomUrl,
        getRoomSlug,
        getRoomBaseUrl,
        sortRooms,
        addSubdomain,
        getPersonalRooms,
      };
    }
  ).name;
